import { render } from "./HowItWorksPage.vue?vue&type=template&id=4ae2fd8b&scoped=true"
import script from "./HowItWorksPage.vue?vue&type=script&lang=js"
export * from "./HowItWorksPage.vue?vue&type=script&lang=js"

import "./HowItWorksPage.vue?vue&type=style&index=0&id=4ae2fd8b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae2fd8b"]])

export default __exports__